import { httpCreators, HttpResponse } from 'rbh-merchant-core';
import { call, put, takeLatest } from 'redux-saga/effects';
import { generalCreators } from '../redux/general/general-action';
import { MODAL_TYPE } from '../redux/general/general-constant';
import { GENERAL_STATE_KEY } from '../redux/general/general-reducer';
import { StoreRegistryHelper } from '../shared/helpers/store-registry-helper';
import { Classification } from '../shared/models/classification';
import { mainCreators } from './main-action';
import { COMFIRM_ALL_CHANGE, MAIN_REQUEST_ID_LIST, MASTER_DATA_TYPE } from './main-constant';
import { MAIN_STATE_KEY } from './main-reducer';
import { MainService } from './main-service';
import { MAIN_ACTION_TYPE } from './main-type';
import { AuthHelper } from '../auth/auth-helper';
import { registerLocalStorage } from '../shared/helpers/utility';
import { AUTH_LOCAL_STORAGE_KEY } from '../auth/auth-constant';

function* getMasterDataHandler(resp: HttpResponse) {
  if (resp.success) {
    const obj: any = {
      codes: {},
      schemes: {}
    };

    resp.data.forEach((element: Classification) => {
      const code = element.classificationCode;
      const scheme = element.scheme;

      // classificationCode
      obj.codes[code] = element;

      // scheme
      if (!obj.schemes[scheme]) {
        obj.schemes[scheme] = [];
      }

      obj.schemes[scheme].push(code);
    });

    yield put(mainCreators.setMainState(MAIN_STATE_KEY.MASTER_DATA_STATUS, MASTER_DATA_TYPE.SUCCESS));
    yield put(mainCreators.setMainState(MAIN_STATE_KEY.MASTER_DATA, obj));
  } else {
    yield put(mainCreators.setMainState(MAIN_STATE_KEY.MASTER_DATA_STATUS, MASTER_DATA_TYPE.FAIL));
  }
}

function* postConfirmAllChangeHandler(resp: HttpResponse) {
  if (resp.success) {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      modalTitle: 'main.confirm_all_change.success.title',
      modalContent: 'main.confirm_all_change.success.content',
      type: MODAL_TYPE.SUCCESS
    }));
  } else if (resp.statusCode === 1899) {
    if (resp.data && resp.data.translationKey) {
      switch (resp.data.translationKey) {
        case COMFIRM_ALL_CHANGE.NO_VAT_ADDRESS:
          yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
            visible: true,
            modalTitle: 'main.confirm_all_change.no_vat_address.title',
            modalContent: 'main.confirm_all_change.no_vat_address.content',
            type: MODAL_TYPE.ERROR
          }));
          break;
        case COMFIRM_ALL_CHANGE.NO_MENU:
          yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
            visible: true,
            modalTitle: 'main.confirm_all_change.no_menu.title',
            modalContent: 'main.confirm_all_change.no_menu.content',
            type: MODAL_TYPE.ERROR
          }));
          break;
      }
    } else {
      yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
        visible: true,
        type: MODAL_TYPE.ERROR
      }));
    }
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* callMasterDataAndLandingStatusHandler() {
  yield call(callMasterData);
}

function* callMasterData() {
  yield put(mainCreators.setMainState(MAIN_STATE_KEY.MASTER_DATA_STATUS, MASTER_DATA_TYPE.BLANK));
  yield put(httpCreators.request({
    id: MAIN_REQUEST_ID_LIST.GET_MASTER_DATA,
    sagaHandler: getMasterDataHandler as any,
    callbackParams: '',
    service: MainService.getMasterData,
    serviceParams: ''
  }));
}

function* postConfirmAllChange() {
  yield put(httpCreators.request({
    id: MAIN_REQUEST_ID_LIST.POST_CONFIRM_ALL_CHANGE,
    sagaHandler: postConfirmAllChangeHandler as any,
    callbackParams: '',
    service: MainService.postConfirmAllChange,
    serviceParams: ''
  }));
}

function* preload() {
  yield put(mainCreators.setMainLoading(MAIN_REQUEST_ID_LIST.GET_PRELOAD, true));
  const resp: HttpResponse = yield call(MainService.getPreload);
  if (resp.success) {
    yield call(registerLocalStorage, AUTH_LOCAL_STORAGE_KEY.MERCHANT_TYPE_ID, resp.data?.merchantTypeId);
    yield call(registerLocalStorage, AUTH_LOCAL_STORAGE_KEY.BUSINESS_TYPE_ID, resp.data?.businessTypeId);
    yield put(mainCreators.callMasterDataAndLandingStatus());
  } else if (resp.statusCode === 1899 || resp.raw?.response?.status === 403) {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      clickClosable: false,
      type: MODAL_TYPE.ERROR,
      modalContent: 'main.preload.error.modal.content',
      onOk: () => AuthHelper.logOut()
    }));
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      clickClosable: false,
      type: MODAL_TYPE.ERROR,
      onOk: () => StoreRegistryHelper.store.dispatch(mainCreators.callPreload())
    }));
  }
  yield put(mainCreators.setMainLoading(MAIN_REQUEST_ID_LIST.GET_PRELOAD, false));
}

export const mainSagas = {
  getMasterDataHandler,
  postConfirmAllChangeHandler,
  callMasterDataAndLandingStatusHandler,
  callMasterData,
  postConfirmAllChange,
  preload,
  watchers: [
    takeLatest(MAIN_ACTION_TYPE.CALL_MASTER_DATA_AND_LANDING_STATUS, callMasterDataAndLandingStatusHandler),
    takeLatest(MAIN_ACTION_TYPE.POST_CONFIRM_ALL_CHANGE, postConfirmAllChange),
    takeLatest(MAIN_ACTION_TYPE.CALL_PRELOAD, preload)
  ]
};
